"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newbornFieldsShape = exports.newbornFieldsUpdateShape = void 0;
const zod_1 = require("zod");
const lab_newborn_1 = require("../domain/lab-newborn");
/**
 * THE SAME THREE FIELDS ON A DRAFT UPDATE, where `null` means "clear" and absent
 * means "leave as it is" — the one place a bill can stop being a newborn's (the
 * desk unticks the box after the first line is on the bill). A screen that has
 * never heard of newborns sends neither and changes nothing.
 */
exports.newbornFieldsUpdateShape = {
    newbornName: zod_1.z.string().trim().min(lab_newborn_1.NEWBORN_NAME_MIN).max(lab_newborn_1.NEWBORN_NAME_MAX).nullable().optional(),
    newbornAgeDays: zod_1.z.number().int().min(0).max(lab_newborn_1.NEWBORN_MAX_AGE_DAYS).nullable().optional(),
    newbornGender: zod_1.z.enum(lab_newborn_1.NEWBORN_GENDERS).nullable().optional(),
};
/**
 * THE THREE NEWBORN FIELDS, as one spreadable shape.
 *
 * Declared once and spread into every request that can carry a baby — the OP
 * bill draft and the IP charge capture — so the limits cannot drift between the
 * two doors. Every field is optional on its own; "all three or none" is a rule
 * about the SET and is enforced by `newbornFieldsProblem` where the request is
 * handled (a `.refine` here would turn each host object into a `ZodEffects`,
 * which can no longer be `.extend`ed or `.omit`ted by the schemas that build on
 * them).
 */
exports.newbornFieldsShape = {
    /** The baby's name as the desk types it — usually "Baby of <mother>". Printed on the report. */
    newbornName: zod_1.z.string().trim().min(lab_newborn_1.NEWBORN_NAME_MIN).max(lab_newborn_1.NEWBORN_NAME_MAX).optional(),
    /** Whole days of life when the bill was raised; 0 = born today. */
    newbornAgeDays: zod_1.z.number().int().min(0).max(lab_newborn_1.NEWBORN_MAX_AGE_DAYS).optional(),
    newbornGender: zod_1.z.enum(lab_newborn_1.NEWBORN_GENDERS).optional(),
};
//# sourceMappingURL=lab-newborn.schema.js.map